//dependencias
import React, { Component } from 'react';

//componentes
import PorcentajeM from './porcentajeM'

class Index extends Component {

    render(){
        return(
            <div>
                <PorcentajeM />
            </div>
        );
    }

}
export default Index;